module.exports = __webpack_public_path__ + "static/img/rank_154.5a90a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_154.png
// module id = si1I
// module chunks = 1